import React from "react";
import LegalPage from "../components/LegalPage";

export default function Cookies() {
  return (
    <LegalPage title="Política de cookies">
      <h2>O que são cookies</h2>
      <p>
        Cookies são pequenos ficheiros que ajudam um website a recordar
        preferências e compreender a utilização das páginas.
      </p>
      <h2>Como utilizamos</h2>
      <p>
        Podemos utilizar cookies estritamente necessários ao funcionamento e,
        quando aplicável, dados agregados de desempenho.
      </p>
      <h2>Controlo</h2>
      <p>
        O navegador permite bloquear ou eliminar cookies. Algumas
        funcionalidades podem ficar limitadas quando os cookies essenciais são
        desactivados.
      </p>
      <h2>Actualizações</h2>
      <p>
        Esta política pode ser revista para acompanhar alterações no website ou
        nos requisitos aplicáveis.
      </p>
    </LegalPage>
  );
}
